import React, { useContext } from 'react'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next';
import Filter from '../Filter'
import CardContainer from '../CardContainer';
import { GlobalContext } from '../GlobalContext';

const Sidebar = () => {
  const { t } = useTranslation();
  const {
    country,
    setCountry,
    setSector,
    countries,
    pathways,
    sectors,
    setActivePathway,
    sector,
  } = useContext(GlobalContext);

  return (
    <Wrapper>
      <FiltersWrapper>
        <Filter
          title={t('dropdown.country.title')}
          options={countries}
          placeholder={t('dropdown.country.title')}
          onChange={(e) => {
            if (e) {
              setCountry(e.value)
            } else {
              setCountry(null)
            }
            setSector(null)
            setActivePathway(null)
          }}
          selectedOption={countries?.find((item) => item.value === country)}
        />
        { country
          ? (
          <Filter
            title={t('dropdown.sector.title')}
            options={sectors}
            placeholder={t('dropdown.sector.title')}
            onChange={(e) => {
              if (e?.value) {
                setSector(e.value)
              } else {
                setSector(null)
              }

              setActivePathway(null)
            }}
            selectedOption={sectors?.find((item) => item.value === sector) || null}
          />
          ) : (
            null
          )
        }
      </FiltersWrapper>
      <Content>
        <CardContainer pathways={pathways ? pathways : null} />
      </Content>
    </Wrapper>
  )
}


const Wrapper = styled.div`
  box-sizing: border-box;
  position: absolute;
  top: 0;
  left: 0;
  background-color: rgba(255, 255, 255, 0.5);
  z-index: 3;
  width: 30vw;
  height: 100%;
  padding: 1rem;
  display: flex;
  flex-direction: column;

  @media (max-width: 1200px) {
    width: 35vw;
  }

  @media (max-width: 992px) {
    width: 40vw;
  }

  @media (max-width: 768px) {
    width: 100vw;
  }
`

const FiltersWrapper = styled.div`
  flex: 0 0 200px;
`

const Content = styled.div`
  opacity: 1;
  flex: 1;
  overflow-y: scroll;
`
export default Sidebar
